export class PaymentRunContactAPIFilters {
  bankAccountId: number = -1;
  siteId: number = -1;
  onlyIncludeWithBankAccounts: boolean = false;
  landlordId: number = -1;
  contactType: number = -1;
  paymentExportFormat: number = -1;
}
